import Button from '../../../../components/atoms/button/Button';

const AnalystTaskTabs = () => {
  const navigateTo = (path) => {
    window.location.href = path;
  };
  const currentPath = window.location.pathname;
  return (
    <div style={{ display: "flex", gap: 8 , marginLeft: 12}}>
      <Button
        variant={currentPath.endsWith("/analyst-tasks/myassignment") ? "active" : "outlined"}
        onClick={() => navigateTo("/analyst-tasks/myassignment")}
      >
        My Assignments
      </Button>
      <Button
        variant={currentPath.endsWith("/analyst-tasks/peer-review") ? "active" : "outlined"}
        onClick={() => navigateTo("/analyst-tasks/peer-review")}
      >
        Peer Review
      </Button>
    </div>
  );
}

export default AnalystTaskTabs